import { useState, useEffect } from "react";

// MATERIAL UI IMPORTS 
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Tooltip,
  Paper,
  ListSubheader,
  Autocomplete,
  Typography
} from "@mui/material";
import { AddCircleOutline, Delete } from "@mui/icons-material";

export default function ImpuestosComprobante(props) {
  const {
    impuestos,
    uuid,
    datosImpuestos,
    setdatosImpuestos,
    montoMaximo,
    formatNumber,
    empresaFija,
  } = props;

  // Modo ARCA: opciones por categoría para las 3 líneas fijas
  const opcionesIibb = (impuestos ?? []).filter(
    (i) => i.idimpuestos >= 6 && i.idimpuestos <= 27
  );
  const opcionesOtros = (impuestos ?? []).filter(
    (i) => i.idimpuestos === 28 || [29, 33, 34, 35, 36, 37].includes(i.idimpuestos)
  );

  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  const [dataForm, setdataForm] = useState(datosImpuestos);

  /* --------------------------- HANDLERS --------------------------------  */
  const handleInputChange = (index, field, value) => {
    setdatosImpuestos((prevState) => {
      const updatedValues = prevState.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      // console.log("updatedValues", updatedValues);

      return updatedValues;
    });
  };

  const agregarLinea = () => {
    const nuevaLinea = {
      id_impuesto: null,
      // detalle: null,
      // porcentaje_alicuota: null,
      importe: null,
      uuid_comprobante: uuid,
      usuario: localStorage.getItem("user"),
    };
    setdatosImpuestos((prevState) => [...prevState, nuevaLinea]);
  };

  // console.log("datosimpustos", datosImpuestos);


  const handleDeshacerLinea = (index) => {
    setdatosImpuestos((prevState) => {
      if (prevState.length === 1) {
        return prevState;
      }
      const newState = prevState.filter((_, i) => i !== index);
      return newState;
    });
  };

  /* --------------------------- EFFECTS --------------------------------  */
  useEffect(() => {
    setdataForm(datosImpuestos);
  }, [datosImpuestos]);

  /* --------------------------- STYLING --------------------------------  */
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#1f618d",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1f618d",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#1f618d",
    },
  };

  /* --------------------------- RENDER --------------------------------  */
  return (
    <div>
      <Paper
        elevation={3}
        sx={{
          background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
          mt: 1,
          p: 3,
          borderRadius: 4,
          borderLeft: "6px solid #1f618d",
        }}
      >
        {empresaFija && (
          <>
            {/* Percepción de IVA (fija) */}
            <Grid container spacing={2} alignItems="center" mt={0.5}>
              <Grid item xs={12} sm={5}>
                <TextField
                  fullWidth
                  size="small"
                  focused
                  label="Percepción de IVA"
                  value="PERCEPCIÓN IVA"
                  InputProps={{ readOnly: true }}
                  sx={style}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  focused
                  size="small"
                  label="Importe"
                  value={datosImpuestos?.[0]?.importe || ""}
                  onChange={(e) => handleInputChange(0, "importe", formatNumber(e.target.value))}
                  sx={style}
                  onKeyPress={(event) => {
                    const { value } = event.target;
                    if (!/[\d,]/.test(event.key)) event.preventDefault();
                    if (event.key === "," && value.includes(",")) event.preventDefault();
                  }}
                />
              </Grid>
            </Grid>

            {/* Percepción de Ingresos Brutos (buscable) */}
            <Grid container spacing={2} alignItems="center" mt={0.5}>
              <Grid item xs={12} sm={5}>
                <Autocomplete
                  size="small"
                  options={opcionesIibb}
                  getOptionLabel={(o) => o.descripcion || ""}
                  value={opcionesIibb.find((o) => o.idimpuestos === datosImpuestos?.[1]?.id_impuesto) || null}
                  isOptionEqualToValue={(o, v) => o.idimpuestos === v.idimpuestos}
                  onChange={(e, v) => handleInputChange(1, "id_impuesto", v ? v.idimpuestos : null)}
                  renderInput={(params) => (
                    <TextField {...params} label="Percepción de Ingresos Brutos" focused sx={style} />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  focused
                  size="small"
                  label="Importe"
                  value={datosImpuestos?.[1]?.importe || ""}
                  onChange={(e) => handleInputChange(1, "importe", formatNumber(e.target.value))}
                  sx={style}
                  onKeyPress={(event) => {
                    const { value } = event.target;
                    if (!/[\d,]/.test(event.key)) event.preventDefault();
                    if (event.key === "," && value.includes(",")) event.preventDefault();
                  }}
                />
              </Grid>
            </Grid>

            {/* Otros */}
            <Grid container spacing={2} alignItems="center" mt={0.5}>
              <Grid item xs={12} sm={5}>
                <FormControl fullWidth size="small" focused sx={style}>
                  <InputLabel>Otros</InputLabel>
                  <Select
                    label="Otros"
                    value={datosImpuestos?.[2]?.id_impuesto || ""}
                    onChange={(e) => handleInputChange(2, "id_impuesto", e.target.value)}
                  >
                    {opcionesOtros.map((o) => (
                      <MenuItem key={o.idimpuestos} value={o.idimpuestos}>
                        {o.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  focused
                  size="small"
                  label="Importe"
                  value={datosImpuestos?.[2]?.importe || ""}
                  onChange={(e) => handleInputChange(2, "importe", formatNumber(e.target.value))}
                  sx={style}
                  onKeyPress={(event) => {
                    const { value } = event.target;
                    if (!/[\d,]/.test(event.key)) event.preventDefault();
                    if (event.key === "," && value.includes(",")) event.preventDefault();
                  }}
                />
              </Grid>
            </Grid>
          </>
        )}

        {!empresaFija && dataForm.map((dato, index) => (
          <Grid
            container
            spacing={2}
            alignItems="center"
            mt={0.5}
            key={index}
          >
            <Grid item xs={12} sm={5}>
              <FormControl
                fullWidth
                style={style}
                focused
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#1f618d",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1f618d",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#1f618d",
                  },
                }}
              >
                <InputLabel>Impuestos</InputLabel>
                <Select
                  label="Impuestos"
                  value={dato.id_impuesto || ""}
                  onChange={(e) => handleInputChange(index, "id_impuesto", e.target.value)}
                >
                  {/* {(impuestos ?? []).map((elemento) => (
                    <MenuItem key={elemento.idimpuestos} value={elemento.idimpuestos}>
                      {elemento.descripcion}
                    </MenuItem>
                  ))} */}
                  {/* --- SECCIÓN OTROS / RESTO --- */}
                  <ListSubheader sx={{ fontWeight: 'bold', color: '#1f618d', backgroundColor: '#f0f4f8' }}>
                    Otros Impuestos
                  </ListSubheader>
                  {(impuestos ?? [])
                    .filter(e => ![29, 33, 34, 35, 36, 37].includes(e.idimpuestos))
                    .map((elemento) => (
                      <MenuItem key={elemento.idimpuestos} value={elemento.idimpuestos}>
                        {elemento.descripcion}
                      </MenuItem>
                    ))
                  }
                  <ListSubheader sx={{ fontWeight: 'bold', color: '#1f618d', backgroundColor: '#f0f4f8' }}>
                    Impuestos Petroleras
                  </ListSubheader>
                  {(impuestos ?? [])
                    .filter(e => [29, 33, 34, 35, 36, 37].includes(e.idimpuestos))
                    .map((elemento) => (
                      <MenuItem key={elemento.idimpuestos} value={elemento.idimpuestos}>
                        {elemento.descripcion}
                      </MenuItem>
                    ))
                  }


                </Select>

              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={3.2}>
              <TextField
                required
                onChange={(e) =>
                  handleInputChange(index, "detalle", e.target.value)
                }
                value={dato.detalle || ""}
                focused
                name="detalle"
                style={style}
                size="small"
                label="Detalle"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#1f618d",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1f618d",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#1f618d",
                  },
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                focused
                style={style}
                required={dato.id_impuesto !== null}
                size="small"
                label="Importe"
                value={dato.importe || ""}
                onChange={(e) => handleInputChange(index, "importe", formatNumber(e.target.value))}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#1f618d",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1f618d",
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#1f618d",
                  },
                }}
                onKeyPress={(event) => {
                  const { value } = event.target;
                  if (!/[\d,]/.test(event.key)) event.preventDefault();
                  if (event.key === "," && value.includes(",")) event.preventDefault();
                }}
              />
            </Grid>

            <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Tooltip title="Eliminar línea">
                <span>
                  <IconButton
                    color="error"
                    disabled={index === 0}
                    onClick={() => handleDeshacerLinea(index)}
                    sx={{
                      color: "#e74c3c",
                      "&:hover": { backgroundColor: "rgba(231, 76, 60, 0.1)", transform: "scale(1.1)" },
                    }}
                  >
                    <Delete />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Agregar línea">
                <span>
                  <IconButton
                    disabled={index !== dataForm.length - 1}
                    color="primary"
                    onClick={agregarLinea}
                    sx={{
                      color: "#1f618d",
                      "&:hover": { backgroundColor: "rgba(31, 97, 141, 0.1)", transform: "scale(1.1)" },
                    }}
                  >
                    <AddCircleOutline />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        ))}
      </Paper>
    </div>
  );
}
